export default {"src":"/_next/static/media/secure.238eb5a5.svg","height":61,"width":60};